module.exports = __webpack_public_path__ + "static/img/header2.b2225362.jpeg";